import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Coins, PlusCircle, LogOut, User } from 'lucide-react';
import { supabase } from '../lib/supabase';
import type { Session } from '@supabase/supabase-js';

interface NavbarProps {
  session: Session;
}

const Navbar: React.FC<NavbarProps> = ({ session }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => {
    return location.pathname === path ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600';
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-lg transition-shadow duration-300">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <Coins className="h-6 w-6 text-blue-600" />
            <span className="text-xl font-semibold">Numismatic Gallery</span>
          </Link>
          <div className="flex items-center space-x-8">
            <Link to="/" className={`${isActive('/')} font-medium transition-colors duration-200`}>
              Coins
            </Link>
            <Link to="/collections" className={`${isActive('/collections')} font-medium transition-colors duration-200`}>
              Collections
            </Link>
            <Link 
              to="/add-coin" 
              className="flex items-center space-x-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all duration-200 hover:shadow-md"
            >
              <PlusCircle className="h-5 w-5" />
              <span>Add Coin</span>
            </Link>
            <div className="flex items-center space-x-4">
              <Link
                to="/profile"
                className="flex items-center space-x-1 text-gray-600 hover:text-blue-600 transition-colors duration-200"
              >
                <User className="h-5 w-5" />
                <span>Profile</span>
              </Link>
              <button
                onClick={handleSignOut}
                className="flex items-center space-x-1 text-gray-600 hover:text-red-600 transition-colors duration-200"
              >
                <LogOut className="h-5 w-5" />
                <span>Sign out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;